<template>
   <div class="crud-wrapper">
      <crud-toolbar :modal-mode="modalMode" :new-state="newState" :show-back="false" :title="modalTitle"
                    @onCommand="toolbarCommand"></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" fullWidth v-model="validForm">

         <v-layout row wrap>
            <div style="padding: 10px 15px; display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%">
               <div style="display: flex; flex-direction: column;">
                  <label style="font-size: 12px; color: #6E6E6E;">Para a Campanha</label>
                  <label style="font-size: 18px;">{{campaignName}}</label>
               </div>
               <a style="text-decoration: none;" :href="modelXlsx"><v-btn style="margin: 0;">Baixar modelo</v-btn></a>
            </div>
            <v-flex xs12>
               <file-pond
                       accepted-file-types="Excel/xlsx, CSV/csv"
                       allow-multiple="true"
                       drop-on-page="true"
                       drop-validation="true"
                       instantUpload="false"
                       label-idle="Arraste e solte arquivos* aqui, ou clique para escolher..."
                       labelTapToRetry="tentar novamente"
                       labelTapToCancel="cancelar"
                       labelFileProcessingError="Erro no upload"
                       labelFileProcessingComplete="Upload concluído"
                       labelButtonRemoveItem="Remover"
                       labelButtonAbortItemProcessing="Cancelar"
                       labelButtonProcessItem="Carregar"
                       ref="pond"
                       :server="{
                          url: serverHost,
                          process: {
                             url: '/ds/uploadManager/excelForCampaign',
                             method: 'POST',
                             headers: {
                                'Authorization': `Bearer ${AuthToken}`
                             }
                          }

                       }">
               </file-pond>
            </v-flex>
            <v-flex xs12>
               <label class="caption grey--text">* O(s) arquivo(s) serão tratados pela equipe Consigmais em até 72hs e disponibilizados nesta campanha automaticamente.</label>
            </v-flex>
         </v-layout>

      </crud-form>

   </div>
</template>

<script>
   import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';
   import vueFilePond from 'vue-filepond';
   import axios from 'axios';

   export default CrudFormClass.extend({
      name: 'ImportForm',

      props: ['campaign'],

      components: {
         FilePond: vueFilePond()
      },

      data () {
         return {
            title: 'Importar Planilha',
            formName: 'importForm',

         };
      },

      computed: {
         serverHost() {
            return this.$api.serverHost;
         },
         modelXlsx() {
            return this.serverHost + '/files/model.xlsx';
         },
         campaignName() {
            return this.campaign ? this.campaign.name : '(Campanha não Detectada)';
         },
         AuthToken() {
            return window.localStorage.getItem('stAuthToken');
         }
      },
   });

</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/pages/CampaignDataImport.vue